import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { DraftedGroupShipments } from '@uturn/portal/modules/shipments';
import {
	GroupedShipmentsSearchSchema,
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_DRAFTED,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const DraftedGroupedShipmentsSearchSchema = GroupedShipmentsSearchSchema.extend(
	{
		'filter.statuses': fallback(
			ShipmentsSearchStatusesSchema.array(),
			SHIPMENTS_SEARCH_DEFAULT_STATUSES_DRAFTED,
		).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_DRAFTED),
	},
);

export const Route = createFileRoute(
	'/_protected/shipments/groups/$groupId/drafted',
)({
	component: DraftedGroupShipments,
	validateSearch: zodValidator(DraftedGroupedShipmentsSearchSchema),
});
